import { Injectable, Injector} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { SyncService } from "./sync.service";

export class CompletedWorksModel {
  Id: number = 0;
  ObjectId: number = 0;
  ObjectName: string = "";

  Name: string = "";
  Comment: string = "";
  Address: string = "";

  Time: number = new Date().getTime();
  Odometr: number = 0;
  WorkTime: number = 0;
  Duration: number = 0;

  Cost: number = 0;
  ServiceTasks: number[] = [];

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.ObjectId = data["objectId"];
      this.Name = data["name"];
      this.Comment = data["comment"];
      this.Address = data["address"];
      this.Time = data["time"];
      this.Odometr = data["odometr"];
      this.WorkTime = data["workTime"];
      this.Cost = data["cost"];
      this.Duration = data["duration"];
      this.ServiceTasks = data["serviceTasks"]
    }
  }

  static fromJS(data: any): CompletedWorksModel {
    data = typeof data === 'object' ? data : {};
    let result = new CompletedWorksModel();
    result.init(data);
    return result;
  }
}

@Injectable()
export class CompletedWorksService
{
  protected syncService: SyncService;
  protected client: HttpClient;

  constructor(protected injector: Injector)
  {
    this.syncService = injector.get(SyncService);
    this.client = injector.get(HttpClient);
  }

  public get(id: number)
  {
    return this.client.get<any>("/ctrl/completedwork/"+id).pipe(map(values => {
      return CompletedWorksModel.fromJS(values);
    }));
  }

  public update(model: CompletedWorksModel) {
    return this.client.put("/ctrl/completedwork", model).pipe(map(values => {
      this.syncService.NotifyEntityChanged("CompletedWorks", model.Id);
      return values;
    }));
  }

  public delete(id: number)
  {
    return this.client.delete("/ctrl/completedwork/" + id).pipe(map(values => {
      this.syncService.NotifyEntityChanged("CompletedWorks", id);
      return values;
    }));
  }
}
